/**
 * @internal
 */
function hthvItem({ $ = 'raw', n, t, v, x = [], p = {}, pl = [], }) {
    if (n) {
        p[n] = { $, n, v, x: [], p: {}, pl: [] };
    }
    return {
        $,
        n,
        t,
        v,
        x,
        p,
        pl,
    };
}

/**
 * @internal
 */
function hthvParseTrivial(value) {
    if (typeof value === 'string') {
        return value.split(',').map(item => item.trim());
    }
    const result = [];
    for (const val of value) {
        result.push(...hthvParseTrivial(val));
    }
    return result;
}
/**
 * @internal
 */
function hthvParseFirstTrivial(value) {
    if (!value) {
        return value;
    }
    if (typeof value === 'string') {
        const commaIdx = value.indexOf(',');
        return (commaIdx >= 0 ? value.substr(0, commaIdx) : value).trim();
    }
    return hthvParseFirstTrivial(value[Symbol.iterator]().next().value);
}

export { hthvParseTrivial as a, hthvParseFirstTrivial as b, hthvItem as h };
//# sourceMappingURL=_http-header-value.base.js.map
